import React from "react";
import { Route, Switch } from "react-router-dom";
import AppliedRoute from "./components/AppliedRoute";
import AuthenticatedRoute from "./components/AuthenticatedRoute";

import Home from "./containers/Home";
import FleetMap from "./containers/map/FleetMap";
import AlertConfig from "./containers/alert/AlertConfig";
import Trip from "./containers/trip/Trip";
import TripDetail from "./containers/trip/TripDetail";
import Report from "./containers/report/Report";
import Unit from "./containers/unit/Unit";
import Gefence from "./containers/geofence/Geofence";
import Person from "./containers/person/Person";
import Customer from "./containers/customer/Customer";
import NotFound from "./containers/NotFound";

export default ({ childProps }) =>
  <Switch>
    <AppliedRoute path="/" exact component={Home} props={childProps} />

    <AuthenticatedRoute path="/map" exact component={FleetMap} props={childProps} />
    <AuthenticatedRoute path="/alert" exact component={AlertConfig} props={childProps} />
    <AuthenticatedRoute path="/trips" exact component={Trip} props={childProps} />
    <AuthenticatedRoute path="/trips/detail" exact component={TripDetail} props={childProps} />
    <AuthenticatedRoute path="/report" exact component={Report} props={childProps} />
    <AuthenticatedRoute path="/unit" exact component={Unit} props={childProps} />
    <AuthenticatedRoute path="/gefence" exact component={Gefence} props={childProps} />
    <AuthenticatedRoute path="/person" exact component={Person} props={childProps} />
    <AuthenticatedRoute path="/customer" exact component={Customer} props={childProps} />
    { /* Finally, catch all unmatched routes */ }
    <Route component={NotFound} />
  </Switch>;



// WEBPACK FOOTER //
// ./src/Routes.js